import { createTheme } from '@mui/material/styles';

const theme = createTheme(({
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          right: "auto",
          color: "#fff",
          backgroundColor: "#3f51b5",
        },
      }
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          border: "1px solid rgba(0, 0, 0, 0.23)"
        },
        root: {
          color: "black"
        },
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          paddingBottom: "8px",
          paddingInlineStart: "40px",
        },
      }
    },       
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          display: "list-item",
          lineHeight: "1em",
        },
      }
    }, 
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: "1rem",
        },
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#f50057",
        }
      },
    },     
    MuiTab: {
      styleOverrides: {
        root: {
          color: "inherit",
          "&.Mui-selected": {
            color: "black !important",
          },
        },
      },
      variants: [
        {
          props: { variant: "styledTab" },
          style: {
            textTransform: 'capitalize',
            fontSize: '1.0rem',
            minHeight: '1.25rem',
            lineHeight: '1.75rem',
            padding: '0',
            "&:focus": {
              fontWeight: "bold",
            },
            "&:hover": {
              backgroundColor: "lightblue",
            },
          },
        },
        {
          props: { variant: "dividerTab" },
          style: {
            textTransform: 'capitalize',
            fontSize: '1.0rem',
            minHeight: '1.25rem',
            lineHeight: '1.75rem',
            fontStyle: 'italic',
            padding: '0.5em 0 0',
            color: '#3f51b5 !important',
            opacity: "1.0 !important",
          },
        },
        {
          props: { variant: "noshow" },
          style: {
            minHeight: 0,
            lineHeight: 0,
            padding: 0,
          },
        },
      ],
    },
  },
}))

export default theme